import { render, staticRenderFns } from "./loyalty_reward.vue?vue&type=template&id=4e75969c&scoped=true&"
import script from "./loyalty_reward.vue?vue&type=script&lang=js&"
export * from "./loyalty_reward.vue?vue&type=script&lang=js&"
import style0 from "./loyalty_reward.vue?vue&type=style&index=0&id=4e75969c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e75969c",
  null
  
)

export default component.exports